export default "__VITE_ASSET__CyIpILTE__"